import { MondayLogoKonva } from "frontend/icons/monday-logo";
import { Line, Rect, Shape, Group } from "react-konva";
import { EditableText } from "frontend/editableText";
import { FontProperties } from "shared/datamodel/schemas";
import { noop } from "frontend/utils/fn-utils";

const HeaderHeight = 40;

export function LiveCardStackFrame({
  x,
  y,
  width,
  height,
  title,
  isEditing,
  onStopEditing,
  onChangeTitle = noop,
  showSubitems,
  onShowSubItems,
  name,
}: {
  x: number;
  y: number;
  width: number;
  height: number;
  title?: string;
  isEditing: boolean;
  onStopEditing?: () => void;
  onChangeTitle?: (newValue: string) => void;
  showSubitems?: boolean;
  onShowSubItems?: () => void;
  name?: string;
}) {
  return (
    <Group x={x} y={y} name={name}>
      <Rect
        width={width}
        height={height}
        fill="#fff"
        stroke="#EBEDF3"
        strokeWidth={1}
        strokeEnabled={true}
        cornerRadius={10}
        listening={false}
        shadowEnabled={true}
        shadowBlur={10}
        shadowColor="rgba(17, 51, 87, 0.15)"
        shadowOffsetY={3}
      />
      <Line
        points={[0, HeaderHeight + 1, width, HeaderHeight + 1]}
        stroke="#EBEDF3"
        strokeWidth={1}
        listening={false}
      />
      <MondayLogoKonva x={18} y={HeaderHeight / 2 - 4} width={18} height={10} />
      <EditableText
        x={45}
        y={2}
        fill="#113357"
        font="Poppins"
        fontSize={14}
        fontProps={FontProperties.Bold}
        verticalAlign="middle"
        isFixedHeight={true}
        width={width - 200}
        height={HeaderHeight}
        isEditing={isEditing}
        stopEditingOnEnter={true}
        onStopEditing={onStopEditing}
        onChange={onChangeTitle}
        text={title || ""}
        placeholder={"Add title"}
        ellipsis={true}
      />
      {showSubitems !== undefined && !!onShowSubItems && (
        <Shape
          x={width - 40} // hard coded to align with right side of items (such bad practice, I'm ashamed)
          y={HeaderHeight / 2 - 6}
          onMouseDown={(e) => {
            e.cancelBubble = true;
            onShowSubItems();
          }}
          listening={true}
          fill="transparent"
          sceneFunc={(context) => {
            const ctx = context._context; // get the raw canvas context, not some Konva fluff
            const onColor = "#007AFF",
              offColor = "#7F869B",
              knobColor = "#FFFFFF";
            const isOn = showSubitems;
            const radius = 12 / 2;
            const knobRadius = radius * 0.8;
            const knobX = isOn ? 22 - radius : radius;

            // Draw track
            ctx.fillStyle = isOn ? onColor : offColor;
            ctx.beginPath();
            ctx.roundRect(0, 0, 22, 12, radius);
            ctx.fill();

            // Draw knob
            ctx.fillStyle = knobColor;
            ctx.beginPath();
            ctx.arc(knobX, radius, knobRadius, 0, Math.PI * 2);
            ctx.fill();

            ctx.beginPath();
            ctx.font = "12px Poppins";
            ctx.fillStyle = "#7F869B";
            ctx.textBaseline = "middle";
            ctx.textAlign = "left";
            ctx.fillText("Show subitems", -100, 7); // width=90 pixels
          }}
          hitFunc={(context, shape) => {
            // the toggle and label are clickable
            const ctx = context._context;
            ctx.beginPath();
            ctx.rect(-100, -2, 125, 14);
            context.fillStrokeShape(shape);
          }}
        />
      )}
    </Group>
  );
}
